export default __webpack_public_path__ + "static/media/m-10.44f5a0f9.svg";